import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { updateUserActivityElements, updateUserActivity } from '../../../redux/slices/userActivity';
import { EditText, EditTextarea } from "react-edit-text";

const maxAnswerChar = 3;

export default function ImageWidth() {

    const { selectedUserActivity, userActivities, selectedComponent } = useSelector((state) => state.userActivity);
    const [styles, setStyles] = useState({});
    const [imageWidth, setImageWidth] = useState(null)
    const dispatch = useDispatch()

    useEffect(() => {
        if (styles?.imageWidth) {
            setImageWidth(styles.imageWidth.slice(0, -2))
        } else {
            setImageWidth(null);
        }
    }, [selectedComponent.name, selectedUserActivity, styles, userActivities[selectedUserActivity], selectedComponent.target_id])

    useEffect(() => {
        if (userActivities[selectedUserActivity].elements.length >= 1) {
            let tempElement = userActivities[selectedUserActivity].elements[selectedComponent.target_id];
            const elementAttrib = tempElement?.elementAttributes;
            setStyles(elementAttrib);
        }
    }, [selectedUserActivity, userActivities[selectedUserActivity], selectedComponent.target_id]);

    const handleImageWidth = e => {
        setImageWidth(e.target.value);

        let value;
        if (e.target.value) {
            value = `${e.target.value}px`;
        } else {
            value = null;
        }

        if (userActivities[selectedUserActivity].elements.length >= 1) {
            let tempElement = userActivities[selectedUserActivity].elements[selectedComponent.target_id];
            const elementAttrib = tempElement?.elementAttributes;
            tempElement = {
                ...tempElement,
                elementAttributes: {
                    ...elementAttrib,
                    imageWidth: value,
                },
            };
            // console.log("tempElement", tempElement)
            dispatch(
                updateUserActivityElements({
                    selectedActivityIdx: selectedUserActivity,
                    selectedElementIdx: selectedComponent.target_id,
                    element: tempElement,
                })
            );
        }
    }


    return (
        <div className='EditorRowContainer'>
            <p style={{ marginRight: "1rem" }}>Image Width</p>

            <div style={{ marginRight: "1rem", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <input type="number" min="0" value={imageWidth} id='imageWidth'
                    style={{ border: "1px solid #11111333", borderRadius: "5px", textAlign: "center", width: "2.5rem", height: "2rem", padding: "0" }}
                    onChange={(e) => (e.target.value.length > maxAnswerChar ? null : handleImageWidth(e))} />
                <label style={{ marginLeft: "5px" }}>px</label>
            </div>
        </div>
    )
} 
